/**
 * h5 与APP 交互接口
 */

// import wx from './weixinSdk.js'
import { setLocalStorage, getLocalStorage } from '@/utils/local-storage';
import { Toast } from 'vant';
import Bus from "@/eventBus/index.js";
import { getdSignature } from "@/api/onternetPolitics/index.js";
//判断平台类型
var u = navigator.userAgent;
var isAndroid = u.indexOf("zsweb") > -1 && u.indexOf("android") > -1; //android终端
var isIOS = !!u.indexOf("zsweb") > -1 && u.indexOf("ios") > -1; //ios终端

/**
 * 判断登录状态
 */
export function getLoginStatus() {

    if (isIOS) {
        window.webkit.messageHandlers.appIsLogin.postMessage('appIsLogin');
    } else if (isAndroid) {
        window.android.appIsLogin();
    } else {
        return false
    }
}


/*
*判断是否登录
*/
export function liveHasLogin() {
    // let { Authorization } = getLocalStorage('Authorization')
    // if (Authorization) {
    //     success()
    // } else {
    //     failed()
    // }
    return new Promise((res, rej) => {
        let { Authorization } = getLocalStorage('Authorization')
        if (Authorization) {
            res(Authorization)
        } else {
            rej('用户未登录app')
        }

    })
}

/**
 *打开登录界面
 */
export function opneLoginPane() {
    if (isIOS) {
        console.log(isIOS);
        window.webkit.messageHandlers.appNeedLogin.postMessage('appNeedLogin');
    } else {
        window.android.appNeedLogin();
    }
}
/**
 *返回用户信息
 */
export function getUserInfo() {
    if (isIOS) {
        window.webkit.messageHandlers.getAppUserInfo.postMessage('getAppUserInfo');
    } else {
        return window.android.getAppUserInfo();
    }
}
/**
 *返回当前经纬度
 */
export function getLocation() {
    if (isIOS) {
        window.webkit.messageHandlers.getLocation.postMessage('getLocation');
        const { iosloca } = getLocalStorage('iosloca');
        return iosloca;
    } else {
        return window.android.getLocation();
    }
}
/**
 *显示或隐藏nav
 */
export function setNavStatus(status) {
    if (isIOS) {
        window.webkit.messageHandlers.showTitle.postMessage(status);
    } else {
        window.android.showTitle(status);
    }
}
export function setUser(data) {
    let user = JSON.parse(data);
    let userId = user.data.userId
    let parm;
    if (user.status == 200) {
        parm = {
            nickName: user.data.userNick ?
                user.data.userNick : user.data.userName ?
                    user.data.userName : '',
            avatar: user.data.userHeadPath ?
                user.data.userHeadPath : user.data.iconUrl ?
                    user.data.iconUrl : '',
            appUserid: user.data.userId,
            mobile: user.data.userPhone
        };
        Bus.$emit('update:userInfo', data)
        // SetAppLogin(parm)
        //     .then(res => {
        //         let userInfo = { ...res.data.data.userInfo, userId };

        //         Bus.$emit('update:userInfo', userInfo)
        //         Bus.$emit('initTIM')          
        //         setLocalStorage({
        //             Authorization: res.data.data.token,
        //             avatar: userInfo.avatarUrl ? userInfo.avatarUrl : userInfo.avatar,
        //             nickName: userInfo.nickName,
        //             userId
        //         });

        //     })
        //     .catch(error => {
        //       console.log('错误','bus');
        //         Toast.fail(error.data.errmsg);
        //     });
    }
}
//调取微信兑换
export function getWxPay(data) {
    let parm = JSON.stringify(data);
    if (isIPhone) {
        window.webkit.messageHandlers.openWChatPay.postMessage(parm);
    } else {
        return window.android.openWChatPay(parm);
    }
}
//调取支付宝兑换
export function getAliPay(data) {
    let parm = JSON.stringify(data);
    if (isIOS) {
        window.webkit.messageHandlers.openALiPay.postMessage(parm);
    } else {
        return window.android.openALiPay(parm);
    }
}
//安卓获取授权
export function getAuth() {
    if (isIOS) {
        //苹果无需授权
    } else {
        if (window.android.checkReadFilePermission()) { } else {
            window.android.getReadFilePermission();
        }
    }
}
//微信分享
export function weChatSharing() {
    let link = window.location.href.split("#")[0]
    let downUrl = localStorage.getItem('signat')
    // console.log('地址', downUrl);
    let liveTvCoverimgPath = 'https://share.kailuanxinmeiti.com/share/img/default_cover.png'
    let obj = {
        title: '大美开滦',
        desc: '问政服务平台',
        link: downUrl,
        img: liveTvCoverimgPath,
    }
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    // console.log(isWeixin,obj);
    if (isWeixin) {
        getdSignature({ url: link }).then(({ data }) => {
            if (data.code == 200) {
                // console.log(data.data, obj);
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.data.appId, // 必填，公众号的唯一标识
                    timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.data.noncestr, // 必填，生成签名的随机串
                    signature: data.data.signature, // 必填，签名
                    jsApiList: [
                        // 'updateAppMessageShareData',
                        // 'updateTimelineShareData',
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline'
                    ], // 必填，需要使用的JS接口列表
                });
                wx.ready(() => {
                    wx.onMenuShareAppMessage({
                        title: obj.title,
                        desc: obj.desc,
                        link: obj.link,
                        imgUrl: obj.img,
                        success: function success(res) {
                            // console.log('成功!' + res);
                            // alert('成功!' + imgUrl, obj)
                        },
                        cancel: function cancel(res) {
                            // console.log('取消!' + res);
                            // alert('取消' + JSON.stringify(res), obj)
                        },
                        fail: function fail(res) {
                            // console.log('错误!' + res);
                            // alert('错误' + JSON.stringify(res), obj)
                        },
                    });
                    wx.onMenuShareTimeline({
                        title: obj.title,
                        desc: obj.desc,
                        link: obj.link,
                        imgUrl: obj.img,
                        success: function success(res) {
                            // console.log('成功!' + res);
                            // alert('成功!' + imgUrl)
                        },
                        cancel: function cancel(res) {
                            // console.log('取消!' + res);
                            // alert('取消' + JSON.stringify(res))
                        },
                        fail: function fail(res) {
                            // console.log('错误!' + res);
                            // alert('错误' + JSON.stringify(res))
                        },
                    });
                });
                wx.error((res) => {
                    // console.log(res);
                    // alert('失败' + JSON.stringify(res))
                });
            }
        })
    }

}